var map = {
	"./adelsliga-animation-abstieg-smoke-0.png": 91623,
	"./adelsliga-animation-abstieg-smoke-1.png": 73310,
	"./adelsliga-animation-abstieg-smoke-2.png": 40661,
	"./adelsliga-animation-abstieg-smoke-3.png": 55212,
	"./adelsliga-animation-abstieg-smoke-4.png": 85379,
	"./adelsliga-animation-abstieg-smoke-5.png": 84154,
	"./adelsliga-animation-abstieg-smoke-6.png": 14321,
	"./kleinekrone-animation-rewardshow-cards-sprites-MorphCountFX.png": 95813,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-0.png": 20160,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-1.png": 44361,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-10.png": 56557,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-11.png": 93316,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-2.png": 96178,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-3.png": 17723,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-4.png": 62916,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-5.png": 26157,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-6.png": 94390,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-7.png": 48191,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-8.png": 84776,
	"./kleinekrone-animation-rewardshow-cards-spritesheet-smoketrail-9.png": 33169,
	"./koenigsweg-keylockexplode-smokesmall.png": 81463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90358;